export default "__VITE_ASSET__CPRblqmH__"